import React, { useContext, useEffect, useState } from "react";
import { fetchDataFromApi } from "../../utils/api";
import { Context } from "../../utils/context";
import useFetch from "../../hooks/useFetch";
import { useParams, useSearchParams } from "react-router-dom";
import SingleType from "./SingleType";
import SizeType from "./SizeType";
import ColorType from "./ColorType";
import BothType from "./BothType";

const ProductSingle = () => {
  const { products, setProducts } = useContext(Context);

  const { id } = useParams();

  const { data } = useFetch(`/product/get-product/${id}`);
  const [productIdentity, setProductIdentity] = useState("");

  useEffect(() => {
    getProducts();
    if (data) {
      setProductIdentity(data?.productType);
    }
  }, [data]);

  const getProducts = () => {
    fetchDataFromApi("/product/get-product").then((res) => {
      setProducts(res);
    });
  };

  return (
    <div>
      {data && productIdentity === "Single" ? (
        <SingleType data={data} />
      ) : data && productIdentity === "WithSize" ? (
        <SizeType data={data}></SizeType>
      ) : data && productIdentity === "WithColor" ? (
        <ColorType data={data}></ColorType>
      ) : (
        data &&
        productIdentity === "WithBoth" && <BothType data={data}></BothType>
      )}
    </div>
  );
};

export default ProductSingle;
